<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xZK9K8/image/cover.jpg?1731429783818" alt="This image is the cover for the book Faeries & Elementals for Beginners"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Faeries & Elementals for Beginners
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Explore the magical world where nature spirits dwell</b></p><p>From sprites to will-o'-the-wisps, this practical beginner's guide introduces you to a wide assortment of wild and wondrous creatures. Discover how to attract faeries and elementals to your home and garden, as well as how to befriend them. Along with step-by-step instructions for safely finding and interacting with these powerful creatures, you'll also learn how to:</p>Identify faeries and elementals associated with each of the four classic elements—air, fire, water, and earthPerform rituals, meditations, and exercises that help you connect with nature spirits on a personal levelRequest help from faeries and elementals for healing, protection, getting a job, attracting love, and moreDetermine what roles nature spirits play in folklore and magic throughout the world
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alexandra Chauran
      </h2>
      
      <p class="authorDescription body article"><P><B>Dr. Alexandra Chauran</B>, of Port Moody, Canada, received a master's degree in teaching from Seattle University and a doctorate from Valdosta State University. She is the author of dozens of books, including <I>Crystal Ball Reading for Beginners</I>, <I>Have You Been Hexed?</I>, and <I>Getting Through It</I>. In her spare time she enjoys streaming on Twitch as QueenOfDiamonds and chatting with readers.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd. 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?adf9dffa